<template>
    <el-dialog
        title="新增试题"
        :visible.sync="visible"
        width="11rem"
        class="step-audit-dialog"
        key="exam3Dialog"
        :before-close="handleDialogClose">
        <el-form :model="formData" :rules="rules" ref="subjectDialogForm" :inline="true" key="4" class="user-step-split-form">
            <el-form-item label="试题类型：" class="form-subject-left-item" prop="type">
                <el-select v-model="formData.type" placeholder="请选择试题类型" @change="typeChange">
                    <el-option label="单选" :value="0"></el-option>
                    <el-option label="多选" :value="1"></el-option>
                    <el-option label="问答" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="试题目录：" class="form-subject-left-item" prop="paperGroupIds">
                <el-cascader
                    :options="regions"
                    placeholder="请选择试题目录"
                    :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'childrenList' }"
                    v-model="formData.paperGroupIds"
                    clearable></el-cascader>
            </el-form-item>
            <el-form-item label="试题信息：" class="form-subject-left-item" prop="title">
                <el-input v-model="formData.title" placeholder="请输入试题信息"></el-input>
            </el-form-item>
            <el-form-item label="试题分数：" class="form-subject-left-item" prop="score">
                <el-input-number v-model="formData.score" :precision="2" :step="1"></el-input-number>
            </el-form-item>
            <el-form-item label="试题图片：" class="form-subject-left-item" prop="imgUrl">
                <div class="el-oos-upload">
                    <oosUpload
                    ref="oosRefUpload"
                    fileType="image"
                    :value.sync="fileList"
                    :showFileList="true"
                    class="user-setting-img"
                    :limit="1"
                    ></oosUpload>
                </div>
                
                <!-- <el-input v-model="form.limitTime" placeholder="请输入"></el-input> -->
            </el-form-item>
            <el-form-item label="试题解析：" class="form-subject-left-item" prop="subjectExplain">
                <el-input type="textarea" v-model="formData.subjectExplain" placeholder="请输入试题解析"></el-input>
            </el-form-item>
            <el-form-item label="选项列表：" class="form-subject-left-item" v-if="formData.type === 0 || formData.type === 1">
                <div class="el-options-table">
                    <el-button size="mini" @click="addOption">新增</el-button>
                    <el-table :data="optionData" style="width: 100%">
                        <el-table-column type="index" label="序号" width="80"></el-table-column>
                        <el-table-column prop="name" label="描述">
                            <template slot-scope="scope">
                                <el-input class="el-table-input" v-model="scope.row.content" placeholder="请输入试题信息"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="设为答案" width="100">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.isOption" :active-value="1" :inactive-value="0" active-color="#0E3092" @change="optionChange(scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="action" label="操作" width="80">
                            <template slot-scope="scope">
                                <div class="table-btn table-btn-delete" @click="deleteOption(scope.$index)">
                                    <span style="color:#0E3092;cursor:pointer;ouline:none;">删除</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleDialogClose">取消</el-button>
            <el-button type="primary" size="mini" @click="handleDialogConfirm('subjectDialogForm')">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import oosUpload from '@/components/oosUpload/index.vue'

export default {
    name: 'addSubjectDialog',
    props: ['visible'],
    components: { oosUpload },
    data() {
        return {
            rules: {
                type: [
                    { required: true, message: '请选择试题类型', trigger: 'change' },
                ],
                paperGroupIds: [
                    { required: true, message: '请选择试题目录', trigger: 'change' },
                ],
                title: [
                    { required: true, message: '请输入试题信息', trigger: 'change' },
                ],
                score: [
                    { required: true, message: '请输入试题分数', trigger: 'change' },
                ],
                imgUrl: [
                    { required: true, message: '请上传图片', trigger: 'change' },
                ]
            },
            formData: {
                type: '',
                paperGroupId: '',
                paperGroupIds: [],
                title: '',
                score: 0.00,
                imgUrl: '',
                subjectExplain: ''
            },
            regions: [],
            optionData: [],
            fileList: []
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit('closeDialog')
        },
        handleDialogConfirm(formName) {
            if (this.fileList && this.fileList.length > 0) {
                this.formData.imgUrl = this.fileList[0].url
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let answer = []
                    if (this.optionData.length === 0) {
                        this.$message({ type: 'warning', message: '请添加选项' })
                        return
                    }
                    for (let item of this.optionData) {
                        if (item.content.length === 0) {
                            this.$message({ type: 'warning', message: '选项内容不能为空' })
                            return
                        }
                        if (item.isOption) {
                            answer.push(item)
                        }
                    }
                    if (answer.length === 0) {
                        this.$message({ type: 'warning', message: '请至少添加一个答案' })
                        return
                    }
                    let _params = JSON.parse(JSON.stringify(this.formData))
                    _params.subjectItemResults = this.optionData
                    _params.paperGroupId = _params.paperGroupIds[0]
                    this.subjectListAdd(_params)
                } else {
                    return false;
                }
            })
        },
        addOption() {
            this.optionData.push({
                content: '',
                isOption: 0
            })
        },
        deleteOption(index) {
            this.optionData.splice(index, 1)
        },
        optionChange(row) {
            if (this.formData.type === 1) {
                for (let item of this.optionData) {
                    if (item !== row) {
                        item.isOption = 0
                    }
                }
            }
        },
        subjectListAdd(params) {
            this.$api.user.exam.subjectListAdd(params).then(res => {
                this.$message({ type: 'success', message: '新增成功' })
                this.$emit('confirmDailog', params)
                this.handleDialogClose()
            })
        },
        typeChange() {
            this.optionData = []
            for (let i=0;i<4;i++) {
                this.optionData.push({
                    content: '',
                    isOption: 0
                })
            }
        },
        // 加载条件树
        trainExamTreeList() {
            this.$api.user.exam.trainExamTreeList().then(res => {
                this.regions = res.data
            })
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.trainExamTreeList()
                this.$nextTick(() => {
                    this.$refs.subjectDialogForm.resetFields()
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>

</style>